import { ClientCommerceId, ClientProfile } from "@shared/models";

export interface ClientForm {
  profile: ClientProfile | null;
  businessName: string;
  name: string;
  surname: string;
  email: string;
  dni: string;
  phone: string;
  institutionIds: number[];
  address: string;
  supplierId: number | null;
  erkom: boolean;
  vacuumBell: boolean;
  fmf: boolean;
  fmfModelId: number | null;
  commerceId: ClientCommerceId;
  regionId: number | null;
  institutionCustomName: string;
}
